import { tr } from '@/lib/i18n-core';
import { Badge } from '@/components/ui/primitives';
import { badgeStateOf, badgeVariant, stateLabelKey, type AuthLine, type AuthSourceState } from '../insurance/authorisation';
import { useAuthorisation } from './AuthorisationContext';

export function SourceStateBadge({ state, line, sourceKeys, className }: { state?: AuthSourceState; line?: AuthLine | null; sourceKeys?: readonly (string | null | undefined)[]; className?: string }) {
  const { lineFor } = useAuthorisation();
  const resolved = state ?? badgeStateOf(line ?? lineFor(sourceKeys ?? []));
  if (!resolved) return null;
  return (
    <Badge variant={badgeVariant(resolved)} className={className}>
      {tr('opd', stateLabelKey(resolved))}
    </Badge>
  );
}
